class FaqComponent {
    constructor() {
        this.faqItems = document.querySelectorAll(".faq-item")

        if (!this.faqItems.length) return

        this.addEvents()
    }

    addEvents() {
        this.faqItems.forEach((item) => {
            const trigger = item.querySelector(".faq-trigger")

            trigger.addEventListener("click", () => {
                this.toggleItem(item)
            })
        })
    }

    toggleItem(selectedItem) {

        const content = selectedItem.querySelector(".faq-content")
        const icon = selectedItem.querySelector(".faq-icon")

        // close other items
        this.faqItems.forEach((item) => {

            if (item !== selectedItem) {
                const otherContent = item.querySelector(".faq-content")
                const otherIcon = item.querySelector(".faq-icon")

                otherContent.classList.add("hidden")
                otherIcon.classList.remove("rotate-180")
            }

        })

        // toggle current
        content.classList.toggle("hidden")
        icon.classList.toggle("rotate-180")
    }
}

export default FaqComponent